/**
 * PortalCard — an entry tile on the admin and moderator dashboards.
 *
 * This component existed twice, defined identically inside admin-dashboard.tsx
 * and moderator-dashboard.tsx, and rendered a bespoke `.portal-card` that had
 * neither the border nor the gold frame the student area's cards carry — the
 * most visible reason the two areas looked like different products.
 *
 * It is now the shared <Card> and <Button> primitives, so the dashboards match
 * the student portal by construction rather than by a stylesheet kept in step.
 */

import { useTranslation } from 'react-i18next';
import { Card } from '../../components/card';
import { Button } from '../../components/button';
import styles from './portal-card.module.css';

interface PortalCardProps {
  title: string;
  description: string;
  /** Emoji glyph shown above the title. */
  icon: string;
  onClick?: () => void;
}

export function PortalCard({ title, description, icon, onClick }: PortalCardProps) {
  const { t } = useTranslation();

  return (
    <Card framed className={styles.card}>
      <div className={styles.icon}>{icon}</div>
      <h3 className={styles.title}>{title}</h3>
      <p className={styles.description}>{description}</p>
      <Button variant="gold" block onClick={onClick}>
        {t('dashboard.accessButton')}
      </Button>
    </Card>
  );
}
